import request from '@/api/request'

export default {
  async getAttributes (categoryId) {
    return (await request.get(`module/action/marketplace/gfg/category/attributes/${categoryId}`)).data
  },
  async getBrands () {
    return (await request.get(`module/action/marketplace/gfg/brand/retrieve_all`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/gfg/index.js